import { TypographyMuted } from "@/components/typography/Muted";
import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { generateStandingOfferURL } from "../../utils/generateStandingOfferURL";

interface Props {
  id: string;
  onOpenChange: () => void;
}

export function CopyStandingOfferURL({ id, onOpenChange }: Props) {
  const offerURL = generateStandingOfferURL(id);

  return (
    <Dialog.Root open onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-3xl w-fit">
        <Dialog.Header>
          <Dialog.Description>
            Copy and share the link below to let people subscribe to your app.
          </Dialog.Description>
        </Dialog.Header>

        <Label className="mt-3">Offer URL</Label>
        <div className="h-9 w-fit px-3 py-1 shadow-sm min-w-36 flex flex-row items-center text-sm bg-brand-gray-50/60 dark:bg-brand-gray-800/60 border border-brand-gray-200 dark:border-brand-gray-700 rounded-md">
          <TypographyMuted className="truncate">
            <span className="text-brand-gray-700 dark:text-brand-gray-200">
              {offerURL}
            </span>
          </TypographyMuted>
        </div>

        <Dialog.Footer>
          <Dialog.Close>
            <Button variant="secondary">Close</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
}
